import * as React from 'react'
import { Navigate } from 'react-router-dom'
import { MeContext } from '../../api'
import { isNonAdminSupplier } from '../../api/utils/nonAdminSupplier'
import { Home } from '../Home/Home'
import { SUPPLIER_PORTAL_PATH } from '../SupplierPortal/paths'

/**
 * #7907 — the element registered at `/`. A supplier has no Home: `/` resolves to Opportunities for them,
 * so every path that lands on `/` (the logo, Exit Cloaking, both guards' denial redirect, the 404's Back
 * Home, a bare-URL login) takes them to the page their nav shows. A redirect, not a denial — the app
 * itself sends users here, so there is no toast; `replace` keeps Back from bouncing through `/`.
 *
 * The predicate is #7701's nav-rule population, the shared `isNonAdminSupplier` (`api/utils/`): flag-free,
 * and it includes an admin cloaked into a supplier customer (cloaking clears `isAdmin`). The sidebar omits
 * its Home item on the same predicate, so nav visibility and route resolution agree (reuse-map §1h).
 *
 * Everyone else — every hospital user and every non-cloaked admin — gets `<Home />`, exactly the element
 * this route rendered before.
 */
export const HomeRoute: React.FC = () => {
  const { data: meData } = React.useContext(MeContext)

  return isNonAdminSupplier(meData?.me) ? <Navigate to={SUPPLIER_PORTAL_PATH} replace /> : <Home />
}
